/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section links_list_js
	 ********************************************/
	(function ProductNavTabsModule() {
		var $tabModules;
		var $detailsModule;
		var $fitmentModule;
		var $recommendedModule;
		var $reviewsModule;
		var $questionsModule;
		var $warrantyModule;
		var $installationModule;
		var $details;
		var $fitment;
		var $recommended;
		var $reviews;
		var $questions;
		var $warranty;
		var $installation;
		var $allTabs;
		var displaySingleTabs;
		var detailsOffset;
		var fitmentOffset;
		var recommendedOffset;
		var reviewsOffset;
		var questionsOffset;
		var warrantyOffset;
		var installationOffset;
		var $detailsParent;
		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$tabModules = rp$('.product-tab-nav-module');
			displaySingleTabs = $tabModules.hasClass('display-single-tab');
			rp$.each($tabModules, function DropDownMenu_Iterator(idx, tabModule) {
				var $tabModule = rp$(tabModule);
				$detailsParent = $tabModule;

				function AreThereRecommendations(evt, response) {
					if($recommendedModule.length >= 1) {
						$recommended.css('display', 'inline-block');
						recommendedOffset = $recommendedModule.offset().top;
					}
				}

				// Check for Recommended Parts
				// Due to plugin, all things that depend on document and window are up for causing bugs. Lets clean up before we start
				rp$(document).off('productGetRecommendations:response', AreThereRecommendations);
				rp$(document).on('productGetRecommendations:response', AreThereRecommendations);

				// Check for Reviews
				// We'll do the same kind of check for reviews as we did for Recommended Parts

				// Check for the existence of modules on the page.
				if($detailsModule.length >= 1) {
					$details.css('display', 'inline-block');
					detailsOffset = $detailsModule.offset().top;
				}
				if($fitmentModule.length >= 1) {
					$fitment.css('display', 'inline-block');
					fitmentOffset = $fitmentModule.offset().top;
				}
				if($reviewsModule.length >= 1) {
					$reviews.css('display', 'inline-block');
					reviewsOffset = $reviewsModule.offset().top;
				}
				if($questionsModule.length >= 1) {
					$questions.css('display', 'inline-block');
					questionsOffset = $questionsModule.offset().top;
				}
				if($warrantyModule.length >= 1) {
					$warranty.css('display', 'inline-block');
					warrantyOffset = $warrantyModule.offset().top;
				}
				if ($installationModule.length >= 1) {
					$installation.css('display', 'inline-block');
					installationOffset = $installationModule.offset().top;
				}

				if (displaySingleTabs) {
					removeSectionTitles();
					showModule();
				}
			});
		}

		function removeSectionTitles() {
			rp$('.product-section-title').remove();
		}

		function showModule($selectedTab) {
			if (!displaySingleTabs) {
				return;
			}
			const modules = [
				$detailsModule,
				$fitmentModule,
				$recommendedModule,
				$reviewsModule,
				$questionsModule,
				$warrantyModule,
				$installationModule
			];

			$selectedTab = $selectedTab || $detailsModule;

			modules.forEach(tabModule => {
				if (tabModule && tabModule != $selectedTab) {
					tabModule.hide();
				}
			});

			$selectedTab.show();
		}

		function highlightTitle(moduleTitle) {
			var $moduleTitle = moduleTitle;
			rp$('.product-section-title').removeClass('tab-selected');
			$moduleTitle.find('.product-section-title').addClass('tab-selected');
		}

		// Note: sectionOffset-60 accounts for fixed headers.
		function scrollToSection(selector, sectionOffset) {
			if(!displaySingleTabs) {
				rp$('html, body').animate({scrollTop: sectionOffset-60}, 500);
			}
			$allTabs.removeClass('tab-active');
			rp$(selector).addClass('tab-active');
		}

		$onReady({
			rp$, window,
			label: 'product_tab_nav',
			fn: function () {
				$detailsModule = rp$('.product-details-module');
				$fitmentModule = rp$('.product-fitment-module');
				$recommendedModule = rp$('.product-recommended-module');
				$reviewsModule = rp$('.product-reviews-module');
				$questionsModule = rp$('.product-questions-module');
				$warrantyModule = rp$('.product-warranty-module');
				$installationModule = rp$('.product-installation-module');
				$details = rp$('.product-details-button');
				$fitment = rp$('.product-fitment-button');
				$recommended = rp$('.product-also-purchased-button');
				$reviews = rp$('.product-reviews-button');
				$questions = rp$('.product-questions-button');
				$warranty = rp$('.product-warranty-button');
				$installation = rp$('.product-installation-button');
				$allTabs = rp$('.tab-nav');

				attachEvents();
				// Tab Functions & Scroll to functions
				$details.on('click', function(){
					scrollToSection(this, detailsOffset);
					highlightTitle($detailsParent); // Target Tab Heading on Desktop
					showModule($detailsModule);
				});
				$fitment.on('click', function(){
					scrollToSection(this, fitmentOffset);
					highlightTitle($fitmentModule);
					showModule($fitmentModule);
				});
				$recommended.on('click', function(){
					scrollToSection(this, recommendedOffset);
					highlightTitle($recommendedModule);
					showModule($recommendedModule);
				});
				$reviews.on('click', function(){
					scrollToSection(this, reviewsOffset);
					highlightTitle($reviewsModule);
					showModule($reviewsModule);
				});
				$questions.on('click', function(){
					scrollToSection(this, questionsOffset);
					highlightTitle($questionsModule);
					showModule($questionsModule);
				});
				$warranty.on('click', function () {
					scrollToSection(this, warrantyOffset);
					highlightTitle($warrantyModule);
					showModule($warrantyModule);
				});
				$installation.on('click', function () {
					scrollToSection(this, installationOffset);
					highlightTitle($installationModule);
					showModule($installationModule);
				});
			},
		});

	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
